import { render, staticRenderFns } from "./ListeningPhonics2.vue?vue&type=template&id=03903a8e&scoped=true&"
import script from "./ListeningPhonics2.vue?vue&type=script&lang=js&"
export * from "./ListeningPhonics2.vue?vue&type=script&lang=js&"
import style0 from "./ListeningPhonics2.vue?vue&type=style&index=0&id=03903a8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03903a8e",
  null
  
)

export default component.exports